// js/cues/audio/cursorRestore.js
//
// Forget a sound's saved cursor once its last voice stops.
//
// waveform.js keeps each running cursor's params (startCursor) so a re-render
// mid-playback can restart it — audioFile.js primeWaveform does exactly that
// from getCursorParams(uid). When the last voice of a uid stops, the params
// must go, or the next prime restarts a cursor for a sound that is silent.
//
// A voice's uid is its sound's ("c1"), or that with a suffix for each of
// several voices ("c1__2"); the waveform is the sound's uid, and a pool's
// "wf-pool-<uid>". (Sounds moved over from the retired session layer keep
// their "trigger-<id>" uid, and match the same rule.)
//
// Side-effect module: importing it installs the listener.

import { clearCursorParams } from "../../system/waveform.js";

const soundOf = voiceUid => voiceUid.split("__")[0];
const activeVoicesByItem = new Map(); // sound uid -> Set<voiceUid>
window.addEventListener("oscilla:audio", (e) => {
  const { uid, state } = e.detail || {};
  if (!uid) return;
  const itemId = soundOf(String(uid));
  if (!itemId) return;
  if (state === "play") {
    if (!activeVoicesByItem.has(itemId)) activeVoicesByItem.set(itemId, new Set());
    activeVoicesByItem.get(itemId).add(uid);
  } else if (state === "stop") {
    const voices = activeVoicesByItem.get(itemId);
    if (voices) {
      voices.delete(uid);
      if (voices.size === 0) {
        activeVoicesByItem.delete(itemId);
        // the sound is done: its cursor is not started again on the next prime
        clearCursorParams(itemId);
        clearCursorParams(`wf-pool-${itemId}`);
      }
    }
  }
});
